import React from 'react';
// import { number } from 'joi';
import SelectionTab from '../SelectionTab';

export default class SelectionTabMore extends React.Component {
  constructor(props) {
    super(props);
    this.value = this.props.selectMoreOptions.defaultValue ? this.props.selectMoreOptions.defaultValue : 1;
    this.orgValue = this.props.selectMoreOptions.defaultValue ? this.props.selectMoreOptions.defaultValue : 1;
    this.data = this.props.data ? this.props.data : null;
    this.state = {
      isTextInputVisible: false,
    };
  }
  updateValue = (value) => {
    if (this.quantity) {
      this.quantity.setSelectedValue(value);
    }
  }
  onChange = (e) => {
    if (e.target.value === '' || +e.target.value === 0) {
      e.target.value = this.props.selectMoreOptions.defaultValue;
      return;
    }
    this.setState({ value: e.target.value });
    const valObj = {
      id: 'more',
      value: e.currentTarget.value,
      labelResourceId: 'more',
      disabled: false,
      orgValue: this.orgValue,
    };
    if (this.props.handleSelectedOption) {
      if (this.data) {
        this.props.handleSelectedOption(valObj, this.updateValue, this.props.data);
      } else {
        this.props.handleSelectedOption(valObj, this.updateValue);
      }
    }
  }
  handleSelectedOption = (e) => {
    if (e.id !== 'more') {
      if (this.props.handleSelectedOption) {
        if (this.data) {
          this.props.handleSelectedOption({ ...e, orgValue: this.orgValue }, this.updateValue, this.props.data);
        } else {
          this.props.handleSelectedOption({ ...e, orgValue: this.orgValue }, this.updateValue);
        }
      }
    } else {
      this.setState({
        isTextInputVisible: true,
      });
    }
  }
  handleAllowOnlyDigit = (e) => {
    const numbers = e.target.value;
    if (numbers !== '' && +numbers === 0) {
      e.target.value = this.props.selectMoreOptions.defaultValue;
    }
    e.target.value = numbers.replace(/\D/g, '');
  }

  render() {
    this.value = this.props.selectMoreOptions.defaultValue ? this.props.selectMoreOptions.defaultValue : 0;
    this.orgValue = this.props.selectMoreOptions.defaultValue ? this.props.selectMoreOptions.defaultValue : 0;
    this.data = this.props.data ? this.props.data : null;
    return (
      <div>
        {this.state.isTextInputVisible || (this.props.selectMoreOptions.defaultValue && this.props.selectMoreOptions.defaultValue > 5) ?
          <input
            type="text"
            id={this.props.htmlId}
            className="selectionTabMoreCustomTextInput form-control"
            onBlur={this.onChange}
            defaultValue={this.value}
            maxLength="3"
            onPaste="return false;"
            onChange={(e) => { this.handleAllowOnlyDigit(e); }}
          /> : <SelectionTab
            classname="cSelect selectionTabMoreCustomSelect"
            id={this.props.selectMoreOptions.id}
            optionText={this.props.selectMoreOptions.optionText}
            optionValue={this.props.selectMoreOptions.optionValue}
            selected={this.value}
            value={this.value}
            options={this.props.selectMoreOptions.options} handleSelectedOption={this.handleSelectedOption}
            ref={st => (this.quantity = st)}
          />}
      </div>
    );
  }
}
